(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-ronds-pelotes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-fdm-video-toggle]');
  if (!button) return;
  var circle = button.closest('.fdm-video-ronds__circle');
  var video = circle ? circle.querySelector('video') : null;
  if (!video) return;
  if (video.paused) {
    video.play();
    button.textContent = 'Ⅱ';
    button.setAttribute('aria-label', 'Mettre la vidéo en pause');
  } else {
    video.pause();
    button.textContent = '▶';
    button.setAttribute('aria-label', 'Lire la vidéo');
  }
});
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.fdm-video-ronds__video').forEach(function(video) {
    video.pause();
    var button = video.parentElement.querySelector('[data-fdm-video-toggle]');
    if (button) {
      button.textContent = '▶';
      button.setAttribute('aria-label', 'Lire la vidéo');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
